import * as React from 'react'
import ReactPlayer from 'react-player'

import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionTitle } from '../../components/atoms/SectionTittle'

export const Video: React.FC = () => {
    return (
        <PageWrapper>
            <SectionTitle text="Introduktionsvideo" />
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '40px',
                width: '100%',
            }}>
                <div style={{
                    width: '100%',
                    maxWidth: '1200px',
                    aspectRatio: '16/9'
                }}>
                    <ReactPlayer
                        url="https://www.youtube.com/watch?v=Oi_RtM1vOAQ"
                        width="100%"
                        height="100%"
                        controls
                        style={{
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }}/>
                </div>
            </div>
        </PageWrapper>
    )
}
